function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import { ajax } from 'jquery';
import Evented from '../Evented';
import JSONParseError from './JSONParseError';
var RETRY_DELAY = 2000;
var TIMEOUT = 30000;

function getParams(options) {
  return typeof options.params === 'function' ? options.params() : options.params || {};
}

function parseFrame(data) {
  try {
    return JSON.parse(data);
  } catch (e) {
    throw new JSONParseError(data);
  }
}

var RequestLoop = /*#__PURE__*/function (_Evented) {
  _inheritsLoose(RequestLoop, _Evented);

  function RequestLoop(uri, lastMessageSequence, options) {
    var _this;

    _this = _Evented.call(this) || this;
    _this.didSuccessfullyConnect = false;
    _this.stopRequestLoop = false;
    _this.isConnected = false;
    _this.uri = uri;
    _this.lastMessageSequence = lastMessageSequence;
    _this.options = options;

    _this.request();

    return _this;
  }

  var _proto = RequestLoop.prototype;

  _proto.stop = function stop() {
    this.stopRequestLoop = true;

    if (this.lastRequest) {
      try {
        this.lastRequest.abort();
      } catch (error) {}

      delete this.lastRequest;
    }

    if (this.nextRequest) {
      clearTimeout(this.nextRequest);
      delete this.nextRequest;
    }
  };

  _proto.request = function request() {
    this.lastRequest = ajax({
      url: this.uri,
      method: 'POST',
      data: getParams(this.options),
      timeout: TIMEOUT,
      cache: false,
      crossDomain: true
    });
    this.lastRequest.then(this.onMessage.bind(this)).fail(this.onError.bind(this));
  };

  _proto.onMessage = function onMessage(data, _, xhr) {
    if (this.stopRequestLoop) {
      return;
    }

    if (!this.didSuccessfullyConnect) {
      this.didSuccessfullyConnect = true;
      this.emit('connected', 'initial');
    }

    if (!this.isConnected) {
      this.isConnected = true;
      this.emit('up');
    }

    if (xhr.status === 200) {
      var frame = parseFrame(data);

      if (frame.error === 'Subscription Failed') {
        this.emit('failed', 'subscription', frame);
      }

      if (frame.pong !== 'PONG') {
        var message = JSON.parse(frame.message);

        if (!message.error) {
          this.lastMessageSequence = frame.last_sequence;
          this.nextRequest = setTimeout(this.request.bind(this), 10);
        }

        this.emit('message', message, frame);
      }
    } else if (xhr.status === 204) {
      this.emit('heartbeat');
      this.request();
    }
  };

  _proto.onError = function onError(xhr) {
    var _this2 = this;

    if (this.stopRequestLoop) {
      return;
    }

    if (this.didSuccessfullyConnect) {
      if (this.isConnected) {
        this.isConnected = false;
        this.emit('down');
      }

      this.emit('reconnecting');
      var preflight = this.options.preflight ? this.options.preflight() : Promise.resolve();
      var timer = new Promise(function (resolve) {
        return setTimeout(resolve, RETRY_DELAY);
      });
      Promise.all([preflight, timer]).then(function () {
        return _this2.request();
      });
    } else {
      this.emit('failed', 'connection', xhr);
    }
  };

  return RequestLoop;
}(Evented);

export { RequestLoop as default };